import React, { useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import { actions } from '../redux/ProductReducer';
import { actions as documentActions } from '../redux/DocumentReducer';
import { Loader } from '../../../common/components';
import InternalContainer from '../../layout/containers/Internal';
import ProductTemplateBox from '../components/ProductTemplateBox/ProductTemplateBox';
import AncillarySchemeDocumentList from '../components/DocumentManagement/AncillarySchemeDocumentList/AncillarySchemeDocumentList';
import { ICON_MAP } from '../../../common/components/SvgIcons/productIcons';

const AncillarySchemeDocumentListContainer = ({
  getAncillaryDocuments,
  getAncillarySchemes,
  getAncillaryDocumentType,
  createNewDocument,
  updateDocument,
  getProduct,
  params,
}) => {
  const { productId } = params;

  const { product } = useSelector((state) => state.productManagement);

  const { ancillarySchemeDocuments } = useSelector((state) => state.documentManagement);

  useEffect(
    () => {
      getProduct(productId);
      getAncillaryDocuments(productId);
    },
    [productId, getAncillaryDocuments, getProduct],
  );

  const refresh = () => {
    getAncillaryDocuments();
  };

  const getAncillaryFormInfo = () => {
    return Promise.resolve(getAncillarySchemes()).then(() => {
      return Promise.resolve(getAncillaryDocumentType()).then((resp) => {
        return resp;
      });
    });
  };

  const handleEditDocument = (values) => {
    const documentId = values.data.id;
    return updateDocument(values, documentId);
  };

  const handleAddDocument = (values) => {
    return Promise.resolve(createNewDocument(values)).then(() => {
      getAncillaryDocuments(productId);
    });
  };

  if (!product || !ancillarySchemeDocuments) {
    return (
      <InternalContainer title={'Product Management'}>
        <Loader />
      </InternalContainer>
    );
  }

  const productCode = product.data.attributes.product_code;
  const productName = product.data.attributes.name;

  return (
    <InternalContainer title={'Product Management'}>
      <ProductTemplateBox
        title={'Ancillary Scheme Documents'}
        productIcon={ICON_MAP[productCode]}
        productName={productName}
      >
        <AncillarySchemeDocumentList
          productCode={product?.data?.attributes?.product_code}
          documents={ancillarySchemeDocuments}
          onEditDocument={handleEditDocument}
          onAddDocument={handleAddDocument}
          onRefresh={refresh}
          getAncillaryFormInfo={getAncillaryFormInfo}
        />
      </ProductTemplateBox>
    </InternalContainer>
  );
};

export default connect(
  null,
  {
    getProduct: actions.getProduct,
    getAncillaryDocuments: documentActions.getAncillaryDocuments,
    getAncillarySchemes: actions.getAncillarySchemes,
    createNewDocument: documentActions.createNewDocument,
    updateDocument: documentActions.updateDocument,
    getAncillaryDocumentType: documentActions.getAncillaryDocumentType,
  },
)(AncillarySchemeDocumentListContainer);
